import { GooglePlay } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

const AppsAndroidFilterIcon = () => (
    <GooglePlay
        size="xs"
        color={colorsPalettes.carbon["200"]}
    />
);

export default AppsAndroidFilterIcon;
